export function formatCoordinates(latitude: number, longitude: number): string {
  return `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`
}

export function mapHandoffUrls({
  latitude,
  longitude,
  label,
}: {
  latitude: number
  longitude: number
  label: string
}) {
  const point = `${latitude},${longitude}`
  return {
    apple: `https://maps.apple.com/?daddr=${point}&q=${encodeURIComponent(label)}`,
    google: `https://www.google.com/maps/dir/?api=1&destination=${point}`,
    waze: `https://waze.com/ul?ll=${point}&navigate=yes`,
  }
}
